
import api from './api';

const getBrokers = async () => {
    const response = await api.get('/manager/users/broker');
    return response.data;
};

const getAssignedForms = async () => {
    const response = await api.get('/manager/assigned-forms');
    return response.data;
};

// <<< FIX 5: This function now accepts a single formData object.
const assignForm = async (formData) => {
    // <<< FIX 6: It passes that object directly to the API. This matches what the server needs.
    const response = await api.post('/manager/assign-forms', formData);
    return response.data;
};

const updateAssignedForm = async (formId, updateData) => {
    const response = await api.put(`/manager/assigned-forms/${formId}`, updateData);
    return response.data;
};

const deleteAssignedForm = async (formId) => {
    const response = await api.delete(`/manager/assigned-forms/${formId}`);
    return response.data;
};

const getPageData = async () => {
    try {
        const [assignedFormsResponse, brokersResponse] = await Promise.all([
            getAssignedForms(),
            getBrokers(),
        ]);
        
        // Safely handle cases where the data might not be in the expected nested structure
        const assignedForms = assignedFormsResponse?.assignedForms || assignedFormsResponse || [];
        const brokers = brokersResponse?.brokers || brokersResponse || [];
        
        return { assignedForms, brokers };
    } catch (error) {
        console.error("Failed to get page data:", error);
        return { assignedForms: [], brokers: [] };
    }
};

const addBroker = async (brokerData) => {
    const payload = { ...brokerData, role: 'broker' };
    const response = await api.post('/manager/users/broker', payload);
    return response.data;
};

const toggleBrokerStatus = async (userId, newStatus) => {
    const response = await api.put(`/manager/users/broker/status/${userId}`, { status: newStatus });
    return response.data;
};

const managerService = {
    getBrokers,
    addBroker,
    toggleBrokerStatus,
    getAssignedForms,
    assignForm,
    getPageData,
    updateAssignedForm,
    deleteAssignedForm
};

export default managerService;